import axios from "axios"

import { config } from "@/config"
import { useAuthStore } from "@/features/auth/store/auth-store"
import { queryClient } from "@/lib/query-client"

export const api = axios.create({
  baseURL: config.apiUrl,
})

api.interceptors.request.use((config) => {
  const { token } = useAuthStore.getState()

  if (token) {
    // Ajuste para enviar o token no header que o backend espera
    config.headers["x-access-token"] = token
  }

  return config
})

let isLoggingOut = false

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status

    if (status === 401 && !isLoggingOut) {
      isLoggingOut = true

      const { signOut } = useAuthStore.getState()
      signOut?.()
      queryClient.clear()

      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        window.location.href = "/login"
      }
    }

    return Promise.reject(error)
  },
)

// if (config.isDevelopment) {
//   api.interceptors.request.use(async (config) => {
//     await new Promise((resolve) => setTimeout(resolve, 2000))
//     return config
//   })
// }